<script setup lang="ts">
import { KsDialogDescription } from '@aschehoug/kloss-2'
</script>

<template>
  <KsDialogDescription
    as="div"
    class="dialog-description"
  >
    <slot />
  </KsDialogDescription>
</template>

<style scoped lang="scss">
  .dialog-description {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
    background-color: var(--color-yellow-10);
    color: var(--color-blue-50);

    :deep(.typography) {
      margin: 0;
    }
  }
</style>
